import axios from "axios";
import { API_PATHS } from "../../paths";
import ContactStaff from "../../Model/ContactStaffModel";
import { flashMessage } from "../../../utils/flashMessageService";

/**
 * GET /api/contactstaff
 */
export async function fetchContactStaff(payload = {}) {
  try {
    const res = await axios.get(API_PATHS.contactStaff, {
      headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
      params: payload,
    });
    const items = res.data || [];
    return items.map((i) => ContactStaff.fromJSON(i));
  } catch (error) {
    if (axios.isAxiosError(error) && error.response && error.response.status === 400) {
    console.error(`fetchContactStaff failed with status 400:`, error.response.data);
    flashMessage(`fetchContactStaff failed: ${error.response.data.error}`, { type: "error" });
  } else {
    console.error(`Error fetching contact staff:`, error);
    flashMessage("fetchContactStaff failed. Please try again.", { type: "error" });
  }
    console.error("Error fetching contact staff:", error);
    throw error;
  }
}

/**
 * GET /api/contactstaff/region/:regionId
 */
export async function fetchContactStaffByRegion(regionId, payload = {}) {
  try {
    const res = await axios.get(API_PATHS.contactStaffByRegion(regionId), {
      headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
      params: payload,
    });
    const items = res.data || [];
    return items.map((i) => ContactStaff.fromJSON(i));
  } catch (error) {
    if (axios.isAxiosError(error) && error.response && error.response.status === 400) {
      console.error(`fetchContactStaffByRegion(${regionId}) failed with status 400:`, error.response.data);
      flashMessage(`fetchContactStaffByRegion failed: ${error.response.data.error}`, { type: "error" });
    } else {
      console.error(`Error fetching contact staff by region (${regionId}):`, error);
      flashMessage("fetchContactStaffByRegion failed. Please try again.", { type: "error" });
    }
    throw error;
  }
}

/**
 * POST /api/contactstaff
 */
export async function createContactStaff(payload = {}) {
  try {
    const isFormData = typeof FormData !== 'undefined' && payload instanceof FormData;
    const body = isFormData ? payload : (() => {
      const fd = new FormData();
      Object.entries(payload).forEach(([k, v]) => { if (v !== undefined && v !== null) fd.append(k, v); });
      return fd;
    })();

    const res = await axios.post(API_PATHS.contactStaff, body, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        "Content-Type": "multipart/form-data",
      },
    });
    flashMessage("Contact staff created successfully.", { type: "success" });
    return ContactStaff.fromJSON(res.data);
  } catch (error) {
    if (axios.isAxiosError(error) && error.response && error.response.status === 400) {
    console.error(`create ContactStaff failed with status 400:`, error.response.data);
    flashMessage(`create ContactStaff failed: ${error.response.data.error}`, { type: "error" });
  } else {
    console.error(`Error creating contact staff :`, error);
    flashMessage("create ContactStaff failed. Please try again.", { type: "error" });
  }
    console.error("Error creating contact staff:", error);
    throw error;
  }
}

/**
 * GET /api/contactstaff/:id
 */
export async function fetchContactStaffById(id) {
  try {
    const res = await axios.get(API_PATHS.contactStaffById(id), {
      headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
    });
    return ContactStaff.fromJSON(res.data);
  } catch (error) {
    if (axios.isAxiosError(error) && error.response && error.response.status === 400) {
    console.error(`fetchContactStaffById(${id}) failed with status 400:`, error.response.data);
    flashMessage(`fetchContactStaffById failed: ${error.response.data.error}`, { type: "error" });
  } else {
    console.error(`Error fetching contact staff by id (${id}):`, error);
    flashMessage("fetchContactStaffById failed. Please try again.", { type: "error" });
  }
    console.error(`Error fetching contact staff by id (${id}):`, error);
    throw error;
  }
}

/**
 * PUT /api/contactstaff/:id
 */
export async function updateContactStaff(id, payload = {}) {
  try {
    const isFormData = typeof FormData !== 'undefined' && payload instanceof FormData;
    const body = isFormData ? payload : (() => {
      const fd = new FormData();
      Object.entries(payload).forEach(([k, v]) => { if (v !== undefined && v !== null) fd.append(k, v); });
      return fd;
    })();

    const res = await axios.put(API_PATHS.contactStaffById(id), body, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        "Content-Type": "multipart/form-data",
      },
    });
    flashMessage("Contact staff updated successfully.", { type: "success" });
    return ContactStaff.fromJSON(res.data);
  } catch (error) {
    if (axios.isAxiosError(error) && error.response && error.response.status === 400) {
    console.error(`update ContactStaff(${id}) failed with status 400:`, error.response.data);
    flashMessage(`update ContactStaff failed: ${error.response.data.error}`, { type: "error" });
  } else {
    console.error(`Error updating contact staff (${id}):`, error);
    flashMessage("update ContactStaff failed. Please try again.", { type: "error" });
  }
    console.error(`Error updating contact staff (${id}):`, error);
    throw error;
  }
}

/**
 * DELETE /api/contactstaff/:id
 */
export async function deleteContactStaff(id) {
  try {
    const res = await axios.delete(API_PATHS.contactStaffById(id), {
      headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
    });
    flashMessage("Contact staff deleted successfully.", { type: "success" });
    return res.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response && error.response.status === 400) {
    console.error(`deleteContactStaff(${id}) failed with status 400:`, error.response.data);
    flashMessage(`deleteContactStaff failed: ${error.response.data.error}`, { type: "error" });
  } else {
    console.error(`Error deleting contact staff (${id}):`, error);
    flashMessage("deleteContactStaff failed. Please try again.", { type: "error" });
  }
    console.error(`Error deleting contact staff (${id}):`, error);
    throw error;
  }
}
